import { Stack, Typography } from "@mui/material";
import logo from "../assets/svg/logo-full.svg";
import ContainerLoading from "../components/ContainerLoading";

const Policy = () => (
  <ContainerLoading sx={{ padding: 4 }}>
    <Stack justifyContent="center" width="100%" alignItems="center" my="$6">
      <img
        style={{ maxWidth: "350px", width: "100%", cursor: "pointer" }}
        onClick={() => window.open("https://fightgo.com.br/")}
        src={logo}
        alt="ícone de login"
      />
    </Stack>
    <Typography fontWeight="bold" fontSize="$9" textAlign="center" mt={4}>
      Política de Privacidade do Fight GO{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Por favor, leia esta Política de Privacidade (“Política”) cuidadosamente
      para entender nossas políticas e práticas sobre seus Dados Pessoais
      (“Dados”) e como os tratamos. Esta Política se aplica a indivíduos que se
      cadastram no Fight GO (“você”). Esta Política explica como seus Dados
      Pessoais são coletados, usados e divulgados pelo Fight GO (“Realizador”).
      Ela também informa como você pode acessar e atualizar seus Dados Pessoais
      e tomar certas decisões sobre como seus Dados Pessoais são utilizados.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      1. Coleta de informações pessoais{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Ao se cadastrar no Fight GO, coletamos informações necessárias para a
      criação de seu perfil e acesso ao sistema. Isso inclui:
    </Typography>{" "}
    <br />
    <Typography style={{ paddingLeft: "16px" }}>
      * Nome completo;
      <br /> * Data de nascimento;
      <br /> * CPF ou CNPJ;
      <br /> * Endereço residencial;
      <br /> * Números de telefone fixo e/ou celular;
      <br /> * Dados de pagamento, se aplicável.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      2. Uso das informações pessoais{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Os dados coletados serão utilizados com a finalidade de:{" "}
    </Typography>{" "}
    <br />
    <Typography style={{ paddingLeft: "16px" }}>
      * Administração e operação do Fight GO;
      <br /> * Comunicação com você sobre atualizações, ofertas e
      funcionalidades;
      <br /> * Análise e melhoria dos serviços oferecidos no Fight GO;
      <br /> * Gerenciamento de contas e processos de pagamento.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      3. Compartilhamento de informações pessoais{" "}
    </Typography>
    <Typography>
      Nós não divulgamos suas informações pessoais a terceiros, exceto quando
      necessário para a prestação de serviços solicitados, como processamento de
      pagamentos ou conforme exigido por lei. Nesses casos, compartilhamos
      informações estritamente necessárias com:
    </Typography>{" "}
    <br />
    <Typography>
      * Prestadores de serviços de pagamento;
      <br /> * Assessoria jurídica, se necessário.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      4. Armazenamento e proteção de informações pessoais{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Armazenamos seus dados em servidores seguros e tomamos medidas razoáveis
      para proteger suas informações de acesso não autorizado, alteração,
      divulgação ou destruição.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      5. Acesso e controle de suas informações pessoais{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Você pode acessar, atualizar ou solicitar a exclusão de suas informações
      pessoais a qualquer momento através do menu “Minha Conta” no aplicativo.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      6. Retenção de dados{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Mantemos suas informações pessoais pelo tempo necessário para fornecer os
      serviços solicitados, ou por um período maior se exigido por lei.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      7. Mudanças na Política de Privacidade{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Podemos atualizar nossa Política de Privacidade periodicamente. Avisaremos
      sobre quaisquer mudanças significativas, publicando a nova política no
      aplicativo.
    </Typography>{" "}
    <br />
    <Typography fontWeight="bold" fontSize="$7">
      8. Contato{" "}
    </Typography>{" "}
    <br />
    <Typography>
      Se tiver perguntas ou reclamações sobre nosso uso de suas informações
      pessoais, entre em contato conosco pelo e-mail: suporte@fightgo.com.br.
    </Typography>
  </ContainerLoading>
);

export default Policy;
